import { selector } from 'recoil'

export const cdnConfigState = selector({
  key: 'cdnConfig',
  get: () => {
    return process.env.REACT_APP_ASSET_STORAGE_DOMAIN
  },
})
